import { atom } from 'jotai';

import { PAYMENT_METHODS } from '@entities/payment-plan';

export type SubscriptionStoreState = {
  paymentMethod: string;
  viewloading: boolean;
  btnLoading: boolean;
  error: Record<string, unknown>;
  needToResetForm: boolean;
  applePay: Record<string, unknown>;
  gpayReceived: boolean;
  gpayLoading: boolean;
  unsubscribeData: Record<string, unknown>;
};

export const initialSubscriptionState: SubscriptionStoreState = {
  paymentMethod: PAYMENT_METHODS.Phone,
  viewloading: false,
  btnLoading: false,
  error: {},
  needToResetForm: false,
  applePay: {},
  gpayReceived: false,
  gpayLoading: false,
  unsubscribeData: {},
};

export const subscriptionAtom = atom<SubscriptionStoreState>(initialSubscriptionState);
